const NumberLeadingZero = (num,digits) => {
    var numStr = num.toString();
    while (numStr.length < digits) {
        numStr = '0' + numStr;
    }
    return numStr;
}
export default NumberLeadingZero;